// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerCard_wrapper__UqQdt","icon":"BannerCard_icon__1P-oQ"};